export const ROUTE_PATHS = {
  DEFAULT_PAYMENTS: "/payments",
  COMPLETED_PAYMENTS: "/payments#completed",
  PENDING_PAYMENTS: "/payments#pending",
  OTP: "/auth/verify",
  CHECKOUT: "/checkout",
  MASTERPASS_IFRAME: "/checkout/masterpass-init",
  PAYMENT_FRAME: "/payment-frame",
};
